
export default function Footer() {
  return (
    <footer className="bg-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="md:col-span-1">
            <img 
              src="https://static.readdy.ai/image/7ad4b11beb4e25ee1cc464ef8fd6d856/b4f984a1ec269c2588094398c65df646.png" 
              alt="Texas Workforce Academy" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm">
              Building careers through affordable, high-quality technical education.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-400">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="/privacy" className="text-gray-300 hover:text-yellow-400 transition-colors">Privacy Policy</a>
              </li>
              <li>
                <a href="/terms" className="text-gray-300 hover:text-yellow-400 transition-colors">Terms of Use</a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <p className="text-gray-300 mb-2">940-241-7243</p>
            <p className="text-gray-300">
              <a href="mailto:info@texasworkforceacademy.org" className="hover:text-yellow-400 transition-colors">
                info@texasworkforceacademy.org
              </a>
            </p>
          </div>

          {/* Address */}
          <div>
            <p className="text-gray-300">
              Denton, Texas<br />
              United States
            </p>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2024 Texas Workforce Academy. All rights reserved. | 
            <a href="https://readdy.ai/?origin=logo" className="hover:text-yellow-400 transition-colors ml-1">
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
